var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-practice" }, [
    _c(
      "div",
      { staticClass: "content-box" },
      [
        _vm._m(0),
        _vm._l(_vm.majorList, function (item) {
          return _c(
            "ComponentCollapse",
            {
              key: item.id,
              ref: "component",
              refInFor: true,
              staticClass: "collapse-box",
              attrs: {
                title: item.title,
                name: item.id,
                activeNames: _vm.activeNames,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "title-right",
                  attrs: { slot: "title-right" },
                  slot: "title-right",
                },
                [_c("el-progress", { attrs: { percentage: item.ratio } })],
                1
              ),
              _vm._l(item.node, function (course) {
                return _c(
                  "ul",
                  {
                    key: course.id,
                    staticClass: "collapse-cell",
                    attrs: { slot: "collapseContent" },
                    slot: "collapseContent",
                  },
                  [
                    _c(
                      "li",
                      { staticClass: "item" },
                      [
                        course.make_record
                          ? _c("i", {
                              staticClass: "iconfont icongouxuan primary",
                            })
                          : _c("el-progress", {
                              staticStyle: {
                                "vertical-align": "middle",
                                "margin-right": "10px",
                              },
                              attrs: {
                                width: 20,
                                strokeWidth: 0,
                                type: "circle",
                                percentage: 0,
                                "show-text": false,
                              },
                            }),
                        _c("span", { staticClass: "span tit" }, [
                          _vm._v(_vm._s(course.title)),
                        ]),
                      ],
                      1
                    ),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            (course.make_record &&
                              course.make_record.created_at) ||
                              "--"
                          ) +
                          " "
                      ),
                    ]),
                    _c("li", { staticClass: "item" }, [
                      course.practice_num > 0 && course.subject_total > 0
                        ? _c("span", [
                            _vm._v(
                              "已做：" +
                                _vm._s(course.fulfil_number || 0) +
                                "/总题：" +
                                _vm._s(course.subject_total || 0)
                            ),
                          ])
                        : _c("span", [_vm._v("--")]),
                    ]),
                    _c(
                      "li",
                      { staticClass: "item" },
                      [
                        course.practice_num > 0
                          ? [
                              _c(
                                "span",
                                {
                                  class:
                                    course.task_status === 1 ? "success" : "",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      course.task_status === 1
                                        ? "已完成"
                                        : "未完成"
                                    )
                                  ),
                                ]
                              ),
                              course.learn_status === 1 &&
                              _vm.courseList.is_hours_complete === 1
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "uni-link-btn",
                                      attrs: {
                                        type: "primary",
                                        icon: "el-icon-video-play",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.jump(
                                            "startPractice",
                                            course
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("开始练习")]
                                  )
                                : _vm._e(),
                              _vm.courseList.is_hours_complete === 0
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "uni-link-btn",
                                      attrs: {
                                        type: "primary",
                                        icon: "el-icon-video-play",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.jump(
                                            "startPractice",
                                            course
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("开始练习")]
                                  )
                                : _vm._e(),
                              course.learn_status === 0 &&
                              _vm.courseList.is_hours_complete === 1
                                ? _c("span", { staticClass: "color_999" }, [
                                    _vm._v("未完成学习"),
                                  ])
                                : _vm._e(),
                            ]
                          : _c("div", { staticClass: "gray" }, [
                              _vm._v("无作业练习"),
                            ]),
                      ],
                      2
                    ),
                  ]
                )
              }),
            ],
            2
          )
        }),
        _vm.majorList.length == 0
          ? _c("ComponentEmpty", { attrs: { tips: "", title: "暂无作业进度" } })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "head-box" }, [
      _c("li", { staticClass: "item" }, [_vm._v("课程名称")]),
      _c("li", { staticClass: "item" }, [_vm._v("上次练习时间")]),
      _c("li", { staticClass: "item" }, [_vm._v("做题情况")]),
      _c("li", { staticClass: "item" }, [_vm._v("操作")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }